import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemotePostHealthScheduledAppointments} from 'data/usecases';
import {PostHealthScheduledAppointments} from 'domain/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostHealthScheduledAppointments = (): PostHealthScheduledAppointments =>
	new RemotePostHealthScheduledAppointments(
		makeBFFApiUrl(BookingFlowEndPoints.healthScheduledAppointments),
		makeAuthorizeHttpClientDecorator(),
	);
